import React from 'react';

import { useDispatch } from 'react-redux';

import Alert from '@amzn/meridian/alert';
import Theme from '@amzn/meridian/theme';
import Toaster from '@amzn/meridian/toaster';
import { useAppSelector } from 'src/store/store';
import { onCloseToast } from 'src/store/toastsSlice';

import './siteToaster.scss'

const SiteToaster = () => {
  const dispatch = useDispatch();
  const { toasts } = useAppSelector((state) => state.toasts);

  return (
    <Toaster toasts={toasts} onCloseToast={(toastId) => dispatch(onCloseToast(toastId))}>
      {(toast) => (
        <Theme palette="blue" mode="light">
          <span className="site-toaster">
            <Alert
              data-cy="toast-container"
              data-testid="toast-container"
              toast={true}
              type={toast.type}
              onClose={toast.onClose}
            >
              {toast.message}
            </Alert>
          </span>
        </Theme>
      )}
    </Toaster>
  );
};

export default SiteToaster;
